import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Params } from '@angular/router';
import { CompanyModulesApiObject } from '@qaroni-app/company/types/company-modules-response';
import { CompanyApiObject } from '@qaroni-app/company/types/company-response';
import { ScoreboardsApiObject } from '@qaroni-app/company/types/scoreboards-response';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';
import { CompanyAddress } from '../types/company-address';
import { CompanyRegisterJson } from '../types/company-register-json';
import { CompanyUpdateJson } from '../types/company-update-json';

@Injectable({
  providedIn: 'root',
})
export class CompanyHttpService {
  private http = inject(HttpClient);

  public getCompanies$(params?: Params) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies`;

    return this.http.get<CompanyApiObject>(url, {
      observe: 'response',
      params,
    });
  }

  public registerCompany$(companyRegisterJson: CompanyRegisterJson) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies`;

    return this.http.post<CompanyApiObject>(url, companyRegisterJson, {
      observe: 'response',
    });
  }

  public getCompany$(companyID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}`;

    return this.http.get<CompanyApiObject>(url, { observe: 'response' });
  }

  public updateCompany$(
    companyID: number,
    companyUpdateJson: CompanyUpdateJson
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}`;

    return this.http.patch<CompanyApiObject>(url, companyUpdateJson, {
      observe: 'response',
    });
  }

  public updateCompanyAddress$(companyID: number, address: CompanyAddress) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/addresses`;

    return this.http.patch<CompanyApiObject>(url, address, {
      observe: 'response',
    });
  }

  public removeCompany$(companyID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}`;

    return this.http.delete<CompanyApiObject>(url, { observe: 'response' });
  }

  public getCompanyScoreboards$(companyID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/dashboards`;

    return this.http.get<ScoreboardsApiObject>(url, { observe: 'response' });
  }

  public getCompanyModules$(companyID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/modules`;

    return this.http.get<CompanyModulesApiObject>(url, {
      observe: 'response',
    });
  }
}
